import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ShiftAssignment,
    CreateAssignmentRequest,
    BulkAssignmentRequest,
    MyShift,
} from '../interfaces/shift/ShiftAssignment';

export const ShiftAssignmentService = {
    create: async (institutionId: string, body: CreateAssignmentRequest): Promise<ShiftAssignment> => {
        const response = await axios.post(ENDPOINTS.SHIFT.ASSIGNMENTS_BY_INSTITUTION(institutionId), body);
        return response.data;
    },
    bulkCreate: async (institutionId: string, body: BulkAssignmentRequest): Promise<ShiftAssignment[]> => {
        const response = await axios.post(ENDPOINTS.SHIFT.ASSIGNMENTS_BULK(institutionId), body);
        return response.data;
    },
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.SHIFT.ASSIGNMENT_BY_ID(institutionId, id));
    },
    getActive: async (institutionId: string, userId: string, asOf: string): Promise<ShiftAssignment | null> => {
        try {
            const response = await axios.get(
                ENDPOINTS.SHIFT.ASSIGNMENTS_BY_INSTITUTION(institutionId),
                { params: { userId, asOf } }
            );
            return response.data;
        } catch (e: any) {
            if (e.response?.status === 404) return null;
            throw e;
        }
    },
    listForUser: async (institutionId: string, userId: string): Promise<ShiftAssignment[]> => {
        const response = await axios.get(
            ENDPOINTS.SHIFT.ASSIGNMENTS_BY_INSTITUTION(institutionId),
            { params: { userId } }
        );
        return response.data;
    },
    listCurrent: async (institutionId: string, page = 0, size = 50) => {
        const response = await axios.get(
            ENDPOINTS.SHIFT.ASSIGNMENTS_BY_INSTITUTION(institutionId),
            { params: { page, size } }
        );
        return response.data; // Spring Page<ShiftAssignmentDTO>
    },
    myToday: async (): Promise<MyShift[]> => {
        const response = await axios.get(ENDPOINTS.SHIFT.ME_TODAY);
        return response.data;
    },
    myUpcoming: async (): Promise<MyShift[]> => {
        const response = await axios.get(ENDPOINTS.SHIFT.ME_UPCOMING);
        return response.data;
    },
};
